import i18n from "i18next";
import Backend from "./helpers/i18nHttpBackend";
//import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
	// load translation using fetch -> see /public/locales
	.use(Backend)
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	//.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		//lng: 'ru', it will override any auto-detection.
		defaultNS: 'common',
		//fallbackNS: 'common',
		ns: ["common"],
		backend: {
			/* translation file path */
			loadPath: '/locales/{{lng}}/{{ns}}.json'
		},
		detection: {
			//order: ['querystring', 'cookie', 'header'],
			lookupCookie: 'lang',
			lookupQuerystring: 'lang',
			//cookieDomain: config.url.SERVER_URL,
			caches: ['cookie']
		},
		fallbackLng: "ru", //если не найден перевод, то будет взято значение из fallbackLng
		debug:  process.env.NODE_ENV === "development",

		interpolation: {
			escapeValue: false // not needed for react as it escapes by default
		},
		/*react: { useSuspense: false }*/
	});

export default i18n;
